import { ArrowUUpLeft, Check } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

/**
 * ステージ表示。パスは直線のまま、繰り返し（検証→改訂→調達→試作）は
 * 回数バッジと戻り矢印で表す（レビュー指摘: ループを図で描くと読みにくい）。
 */
export const StageStrip = ({ stages, current, iterations = {}, testid = 'dev-stage-strip' }) => {
  const idx = stages.findIndex((s) => s.id === current);
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      {stages.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        const loops = Number(iterations[s.id] || 0);
        return (
          <div key={s.id} className="flex items-center gap-1.5">
            <span
              data-testid={`dev-stage-${s.id}`}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold',
                active && 'bg-teal-700 text-white border-teal-700',
                done && 'bg-white text-zinc-800 border-zinc-300',
                !active && !done && 'bg-zinc-100 text-zinc-500 border-zinc-200',
              )}
            >
              {done && <Check size={12} weight="bold" />}
              {s.label}
              {loops > 1 && (
                <span
                  data-testid={`dev-stage-iteration-${s.id}`}
                  className={cn('inline-flex items-center gap-0.5 rounded px-1 text-[10px] font-bold',
                    active ? 'bg-white/20 text-white' : 'bg-zinc-200 text-zinc-700')}
                >
                  <ArrowUUpLeft size={10} weight="bold" />{loops}回目
                </span>
              )}
            </span>
            {i < stages.length - 1 && <span className="text-zinc-400 text-xs">›</span>}
          </div>
        );
      })}
    </div>
  );
};
